import React, { Fragment } from 'react';
import ConcessionaireEdit from './ConcessionaireEdit';

const EditConcessionaire = () => {
    return (
        <Fragment>
            <ConcessionaireEdit />
        </Fragment>
    );
};

export default EditConcessionaire;
